export default "__VITE_ASSET__2553a492__"